import { poster } from '~/utils/images';

export const imageList = [
    {
        src: poster,
        alt: 'molarvy-studio team photo one',
    },
    {
        src: poster,
        alt: 'molarvy-studio team photo two',
    },
];
